import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getServiceQuarantineDurations = async (token) => {
    log("welcome in getServiceQuarantineDurations")

    if (!token || token === "") {
        return {error: true, message: "No token provided", durations: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_service_quarantine_durations_api'
        const result = await axios.get(url, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in getServiceQuarantineDurations")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServiceQuarantineDurations", durations: []}
    }
}

export const addServiceQuarantineDuration = async (token, data) => {
    log("welcome in addServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_service_quarantine_duration_api'
        const payload = {
            service_id: data.service_id,
            property_type: data.property_type,
            billing_period_id: data.billing_period_id,
            quarantine_value: data.quarantine_value,
            active: data.active !== false
        }

        const result = await axios.post(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in addServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addServiceQuarantineDuration"}
    }
}

export const updateServiceQuarantineDuration = async (token, data) => {
    log("welcome in updateServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_service_quarantine_duration_api'
        const payload = {
            id: data.id,
            service_id: data.service_id,
            property_type: data.property_type,
            billing_period_id: data.billing_period_id,
            quarantine_value: data.quarantine_value,
            active: data.active
        }

        const result = await axios.put(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in updateServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateServiceQuarantineDuration"}
    }
}

export const deleteServiceQuarantineDuration = async (token, id) => {
    log("welcome in deleteServiceQuarantineDuration")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_service_quarantine_duration_api'
        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        return result.data
    } catch (err) {
        log("Error in deleteServiceQuarantineDuration")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteServiceQuarantineDuration"}
    }
}

export default () => {
    return {
        error,
        getServiceQuarantineDurations,
        addServiceQuarantineDuration,
        updateServiceQuarantineDuration,
        deleteServiceQuarantineDuration
    }
}
